<template>
    <div
        v-if="flash.success"
        class="p-4 my-4 text-sm text-[#046c4f] bg-green-200 rounded-lg"
        role="alert">
        {{ flash.success }}
    </div>
</template>

<script setup>
import {computed} from "vue";
import {usePage} from "@inertiajs/inertia-vue3";

const flash = computed(() => usePage().props.value.flash);
</script>

<style scoped>

</style>
